/**
* 基础菜单 订单管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-date-picker
          v-model="formInline.Date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.orderCode" placeholder="输入订单编号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="输入商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.contactPhone" placeholder="输入联系电话" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.orderStatus" placeholder="请选择订单状态" clearable>
          <el-option label="已取消" value="100"></el-option>
          <el-option label="待付款" value="101"></el-option>
          <el-option label="已付款" value="102"></el-option>
          <el-option label="已出库" value="104"></el-option>
          <el-option label="待收货" value="105"></el-option>
          <el-option label="已完成" value="106"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.sendStatus" placeholder="请选择发货状态" clearable>
          <el-option label="待发货" value="0"></el-option>
          <el-option label="已发货" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.needInvoice" placeholder="请选择是否需要发票" clearable>
          <el-option label="不需要" value="0"></el-option>
          <el-option label="需要" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.hasInvoiceBalance" placeholder="请选择是否有欠票金额" clearable>
          <el-option label="否" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.pay_type" placeholder="请选择支付类型" clearable>
          <el-option label="在线支付" value="211"></el-option>
          <el-option label="线下支付" value="212"></el-option>
          <el-option label="挂账" value="215"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.pay_status" placeholder="请选择结算状态" clearable>
          <el-option label="已结算" value="1"></el-option>
          <el-option label="未结算" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.custName" placeholder="输入会员账号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.receiverName" placeholder="输入收货人" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.hasPayReceipt" placeholder="请选择是否有付款凭证" clearable>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单实付金额价格区间">
        <el-input size="small" v-model="formInline.minAmount" placeholder="" maxLength="7" clearable
                  style="width: 90px"></el-input>
        <span>-</span>
        <el-input size="small" v-model="formInline.maxAmount" placeholder="" maxLength="7" clearable
                  style="width: 90px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="warning" @click="exportExcel">导出</el-button>
        <el-button size="small" type="warning" @click="editPaid" class="edit-button" v-if="isShowEditPaid">修改已付款
        </el-button>
        <el-button size="small" type="success" @click="editPaidVoucher" v-if="isShowEditPaid">修改付款凭证</el-button>
        <el-button size="small" type="danger" plain @click="cancelOrder">取消订单</el-button>
        <el-button size="small" type="primary" plain @click="refundNote">上传/修改退款凭证</el-button>
        <el-button size="small" type="primary" plain @click="getModifyOrder">修改订单商品</el-button>
        <el-button size="small" type="primary" @click="getOrder">结算订单</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 550px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                :summary-method="getSummaries" @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                show-summary
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="submit_time" label="订单提交时间" width="150">
          <template slot-scope="scope">
            <div>{{scope.row.submit_time|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="order_code" label="订单编号" width="135" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <span style="color: #1989FA;cursor: pointer" @click="gotoOrderDetail(scope.row.id)">
              {{scope.row.order_code}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="original_amount" label="订单实付金额" width="120" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div v-if="scope.row.original_amount||scope.row.original_amount==0">￥{{scope.row.original_amount}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="invoice_balance" label="欠票金额" width="100" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_balance||scope.row.invoice_balance==0">￥{{scope.row.invoice_balance}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="会员账号" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="mobile" label="订单总金额" width="100" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div>￥{{scope.row.total_amount}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="使用的优惠券金额" width="120" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div>￥{{scope.row.voucher_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="订单满减金额" width="100">
          <template slot-scope="scope">
            <div>￥{{scope.row.fr_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="need_invoice" label="发票" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.need_invoice==1">需要</div>
            <div v-else>不需要</div>
          </template>
        </el-table-column>
        <el-table-column prop="need_cert" label="公司资质" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.need_cert==1">需要</div>
            <div v-else>不需要</div>
          </template>
        </el-table-column>
        <el-table-column prop="need_product_cert" label="产品三证" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.need_product_cert==1">需要</div>
            <div v-else>不需要</div>
          </template>
        </el-table-column>
        <el-table-column prop="order_status" label="订单状态" width="100">
          <template slot-scope="scope">
            <div plain v-if="scope.row.order_status==100">已取消</div>
            <div plain style="color: #F56C6C" v-if="scope.row.order_status==101">待付款</div>
            <div plain style="color: #409EFF" v-if="scope.row.order_status==102">已付款</div>
            <div plain style="color: #FF00FF" v-if="scope.row.order_status==103">已确认</div>
            <div plain style="color: #E6A23C" v-if="scope.row.order_status==104">已出库</div>
            <div plain style="color: #909399" v-if="scope.row.order_status==105">待收货</div>
            <div plain style="color: #67C23A" v-if="scope.row.order_status==106">已完成</div>
          </template>
        </el-table-column>
        <el-table-column prop="send_status" label="发货状态" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain
                       @click="gotoInvoice(scope.row.send_id,scope.row.submit_time,scope.row.order_code)"
                       v-if="scope.row.send_status=='0'&&scope.row.order_status>101">待发货
            </el-button>
            <el-button type="success" size="mini" plain
                       @click="gotoInvoice(scope.row.send_id,scope.row.submit_time,scope.row.order_code)"
                       v-if="scope.row.send_status=='1'&&scope.row.order_status>101">
              已发货
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="pay_type" label="支付类型" width="100">
          <template slot-scope="scope">
            <div plain v-if="scope.row.pay_type==211">在线支付</div>
            <div plain v-else-if="scope.row.pay_type==212">线下支付</div>
            <div plain v-else-if="scope.row.pay_type==215">挂账</div>
            <div plain v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="pay_status" label="结算状态" width="100">
          <template slot-scope="scope">
            <div plain v-if="scope.row.pay_status==1">已结算</div>
            <div plain v-else>未结算</div>
          </template>
        </el-table-column>
        <el-table-column prop="pay_success_time" label="订单支付时间" width="150">
          <template slot-scope="scope">
            <div>{{scope.row.pay_success_time|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="sendGood(scope.row.send_id,scope.row.id,scope.row.submit_time,scope.row.order_code)"
                       v-if="scope.row.order_status>101&&scope.row.out_status&&scope.row.need_deliver == true"
                       style="width: 80px">
              发货
            </el-button>
            <el-button type="success" size="mini"
                       @click="addInvoice(scope.row.order_code,scope.row.id,scope.row.invoice_balance)"
                       v-if="scope.row.send_status==1&&scope.row.invoice_balance&&scope.row.need_invoice==1"
                       style="width: 80px">添加发票
            </el-button>
            <el-button type="success" size="mini"
                       @click="proxyDetail(scope.row.id)"
                       v-if="scope.row.has_agent_order == true"
                       style="width: 80px">代发详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 发货界面 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeDialog"
               :visible.sync="sendGoodVisible" width="55%" top="7vh" @click="sendGoodVisible = false" center :modal="false" class="backRgba">
      <p class="title f20 color333 fontWeight mb20">发货信息</p>
      <div class="flex_box mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">订单编号</p>
          <span class="color666">{{detailData.order_code}}</span>
        </div>
      </div>
      <div class="flex_box mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">配送方式</p>
          <span class="color666">{{detailData.delivery_com_name}}</span>
        </div>
      </div>
      <div class="flex_box f15 shipping_information mb10">
        <span class="color333 title mr12">收货人信息</span>
        <div class="flex_box" v-if="detailData.receive_name">
          <p class="color666 mr12">
            {{detailData.receive_name}}，{{detailData.receive_phone}}，{{detailData.receive_addr}}</p>
          <span class="copy"
                @click="copy(detailData.receive_name,detailData.receive_phone,detailData.receive_addr)"><img
            src="/static/img/copy.png" alt=""></span>
        </div>
      </div>
      <div class="mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">订单留言</p>
          <span class="color666">{{detailData.order_msg}}</span>
        </div>
      </div>
      <!--列表-->
      <div class="table mt50">
        <div>
          <p class="title f20 color333 fontWeight mb20">待发货商品清单</p>
          <div class="mb20">
            <el-button type="danger" size="mini" @click.native.prevent="batchDeleteRow()">批量移除
            </el-button>
          </div>
        </div>
        <el-table size="small" :data="ordeSendData"
                  highlight-current-row v-loading="loading" border show-summary
                  ref="multipleTable" :summary-method="getSendSummaries" :row-key="rowKey" @selection-change="handleSelectionChange"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="product_code" label="商品编码" width="150" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="product_name" label="销售名称" min-width="220" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="require_send_num" label="客户下单数" width="120">
          </el-table-column>
          <el-table-column prop="sendNum" label="实际发货数" width="120">
            <template slot-scope="scope">
              <div>
                <el-input v-model="scope.row.sendNum" placeholder="发货数" clearable
                          @blur="reviseNum(scope.row.sendNum,scope.row.require_send_num,scope.row.sendEdNum)"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sendEdNum" label="已发货数" width="120">
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click.native.prevent="deleteRow(scope.$index, ordeSendData)">移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block" style="margin-top: 15px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="ordeSendData.length"
          >
          </el-pagination>
        </div>
      </div>
      <p class="title f20 color333 fontWeight mb20 mt50">填写物流信息</p>
      <el-form label-width="120px" :model="deliveryForm" :rules="deliveryrules" ref="deliveryForm" class="delivery">
        <el-form-item label="发货模式" prop="sendMode">
          <el-select v-model="deliveryForm.sendMode" placeholder="请选择发货模式" clearable @change="changeSendMode">
            <el-option label="普通模式" value="2740"></el-option>
            <el-option label="电子面单模式" value="2741"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="deliveryForm.sendMode == 2741">
          <el-form-item label="快递公司" prop="sendDeliveryCompanyId">
            <el-select v-model="deliveryForm.sendDeliveryCompanyId" filterable placeholder="请选择快递公司"
                       @change="popularCompChange(deliveryForm.sendDeliveryCompanyId)">
              <el-option
                style="width: 220px;"
                v-for="item in popularcompDeliveryListData"
                :key="item.id"
                :label="item.name"
                :value="item.com_no">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递类型" prop="deliveryType">
            <el-select v-model="deliveryForm.deliveryType" placeholder="请选择快递类型" clearable>
              <el-option v-for="type in TypeDeliveryListData" :key="type.id" :label="type.name" :value="type.code">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="flex_box">
            <div class="flex_box" style="align-items: center;margin-left: 24%;">
              <p class="bfore f14 color666 mr12 w120 lh40"style="text-align: right;">打印机</p>
              <span class="f14 color333 w220 lh40" v-if="siid">{{ siid }}</span>
              <el-button class="ml10" type="primary" @click="addSelectBox" plain v-else>新增打印机</el-button>
            </div>
          </div>
        </div>
        <div v-else>
          <el-form-item label="快递公司" prop="sendDeliveryCompanyId">
            <el-select v-model="deliveryForm.sendDeliveryCompanyId" filterable placeholder="请选择快递公司" clearable
                       @change="compChange(deliveryForm.sendDeliveryCompanyId)">
              <el-option
                v-for="item in compDeliveryListData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="sendDeliveryCode">
            <el-input size="small" v-model.trim="deliveryForm.sendDeliveryCode" auto-complete="off" maxLength="50" clearable
                      placeholder="请输入快递单号"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">关 闭</el-button>
        <el-button size="small" type="primary" :loading="loading" :disabled="!isCanSubmit" class="title"
                   @click="submitSendForm('deliveryForm')">
          确认发货
        </el-button>
      </div>
    </el-dialog>
    <!-- 添加发票界面 -->
    <el-dialog title="添加发票" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose"
               :visible.sync="addInvoiceVisible"
               width="60%" top="7vh" @click="addInvoiceVisible=false" center>
      <div class="billing_information" style="margin-bottom: 50px" v-if="isNeedInvoice">
        <p class="title f20 color333 fontWeight mb20">会员开票信息</p>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">发票抬头</p>
            <span class="f14 color333">{{invoiceData.company_name}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">注册地址</p>
            <span class="f14 color333" :title="invoiceData.reg_addr">{{invoiceData.reg_addr}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">发票类型</p>
            <span class="f14 color333">{{invoiceData.invoice_type=='180'?'增值税普通发票（纸质发票）':invoiceData.invoice_type=='181'?'增值税普通发票（电子发票）':'增值税专用发票'}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">注册电话</p>
            <span class="f14 color333">{{invoiceData.reg_tel}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">纳税识别号</p>
            <span class="f14 color333">{{invoiceData.identification}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">开户银行</p>
            <span class="f14 color333">{{invoiceData.bank}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">发票内容</p>
            <span class="f14 color333">商品明细</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">开户银行账号</p>
            <span class="f14 color333">{{invoiceData.account}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">收票人手机</p>
            <span class="f14 color333">{{invoiceData.receive_phone}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">电子邮箱</p>
            <span class="f14 color333">{{invoiceData.email}}</span>
          </div>
        </div>
      </div>
      <p class="title f20 color333 fontWeight mb20">新增发票</p>
      <div class="flex_box" style="align-items: center;margin-bottom: 10px">
        <p class="f14 color666 mr12">订单编号</p>
        <span class="f14 color333">{{order_code}}</span>
      </div>
      <el-form label-width="120px" :model="invoiceForm" :rules="rules" ref="invoiceForm" class="delivery">
        <el-form-item label="发票代号" prop="invoice_no">
          <el-input size="small" v-model="invoiceForm.invoice_no" auto-complete="off" placeholder="请输入发票代号" clearable
                    maxLength="20"></el-input>
        </el-form-item>
        <el-form-item label="发票号" prop="invoice_code">
          <el-input size="small" v-model="invoiceForm.invoice_code" auto-complete="off" placeholder="请输入发票号" clearable
                    maxLength="40"></el-input>
        </el-form-item>
        <el-form-item label="开票金额" prop="invoice_money">
          <el-input size="small" v-model="invoiceForm.invoice_money" auto-complete="off" clearable disabled="disabled"
                    placeholder="请输入开票金额" maxLength="10"></el-input>
        </el-form-item>
        <el-form-item label="税率" prop="tax_rate" class="relative">
          <el-input size="small" v-model="invoiceForm.tax_rate" auto-complete="off" placeholder="请输入税率"></el-input>
          <span class="absolute percentage">%</span>
        </el-form-item>
        <el-form-item label="开票日期" prop="invoice_date">
          <el-date-picker
            v-model="invoiceForm.invoice_date"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoice_type">
          <el-select v-model="invoiceForm.invoice_type" clearable placeholder="请选择发票类型" clearable @change="changeType">
            <el-option label="增值税专用发票" value="182"></el-option>
            <el-option label="增值税普通发票（电子发票）" value="181"></el-option>
            <el-option label="增值税普通发票（纸质发票）" value="180"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递公司" prop="deliver_comp"
                      v-if="invoiceForm.invoice_type==180||invoiceForm.invoice_type==182">
          <el-select v-model="invoiceForm.deliver_comp" filterable placeholder="请选择快递公司" clearable
                     @change="deliverChange(invoiceForm.deliver_comp)">
            <el-option
              v-for="item in popularDeliveryListData"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="delivery_no"
                      v-if="invoiceForm.invoice_type==180||invoiceForm.invoice_type==182">
          <el-input size="small" v-model="invoiceForm.delivery_no" auto-complete="off" placeholder="请输入快递单号" clearable
                    maxLength="50"></el-input>
        </el-form-item>

        <el-form-item label="电子发票上传" prop="pdf_url" v-if="invoiceForm.invoice_type==181 || invoiceForm.invoice_type==180||invoiceForm.invoice_type==182">
          <div v-if="invoiceForm.pdf_url">
            <div class="float-left" v-for="(video,index) in productPdfUrl" :key="index">
              <div class="video-list-box" @mouseenter="handleMouseEnter(video.isShowButton,index)"
                   @mouseleave="handleMouseLeave(video.isShowButton,index)">
                <div class="img-mask" v-show="video.isShowButton">
                  <div class="inline_block">
                    <el-upload
                      class="avatar-uploader"
                      action="#"
                      :show-file-list="false"
                      :http-request="uploadFile"
                      :before-upload="uploadDefaultUpload"
                    >
                    </el-upload>
                  </div>
                  <i class="el-icon-zoom-in" @click="lookInvoice"></i>
                  <i class="el-icon-delete" @click="delPdf(index)"></i>
                </div>
                <el-image class="inline_block video-default-img"
                          :src="video.img_url?video.img_url:defaultVideoImg">
                </el-image>
              </div>
            </div>
          </div>
          <div v-else>
            <el-upload list-type="picture-card" :http-request="uploadFile" ref="upload1"
                       v-loading.fullscreen.Tock="videoloading"
                       element-loading-text="拼命上传中" element-loading-spinner="el-icon-loading"
                       element-loading-background="rgba(0,0,0,0.8)"
                       class="float-left avatar-uploader el-upload--text" action="#" :show-file-list="false"
                       :file-list="productPdfFilesList"
                       :before-upload="beforeUploadPdf"
                       >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <div class="note"><span>仅能上传pdf文件，文件大小限制为最大20M</span></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" :disabled="!isCanSubmit"
                   @click="submitInvoiceForm('invoiceForm')">保 存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="paidTitle"
               :visible.sync="editPaidDialogVisible"
               :before-close="paidleClose"
               width="30%"
               center>
      <el-form label-width="120px" :model="editPaidForm" ref="editPaidForm" class="editPaidForm">
        <div v-if="this.ajaxType == 1">
          <template>
            <el-radio v-model="radio" label="212">对公转账</el-radio>
            <el-radio v-model="radio" label="215">挂账</el-radio>
          </template>
          <el-form-item label="支付凭证" prop="list_pic_url" class="list_pic_url" style="margin-top: 20px" v-if="radio == 212">
            <el-image v-if="form.image&&this.ajaxType ==1" :src="form.image" class="avatar" :preview-src-list="srcList"></el-image>
            <el-upload v-else
                       class="avatar-uploader"
                       action="#"
                       :show-file-list="false"
                       :on-remove="handleRemove"
                       :http-request="handleUpload"
                       :before-upload="beforeUpload"
            >
              <img v-if="form.image" :src="form.image" class="avatar"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <div style="text-align: center;color: #D9001B" v-if="radio == 212">单张图片大小不得超过1M，仅支持jpg、jpeg、png格式</div>
        </div>
        <div v-else>
          <el-form-item label="支付凭证" prop="list_pic_url" class="list_pic_url" style="margin-top: 20px">
            <el-image v-if="form.image&&this.ajaxType ==1" :src="form.image" class="avatar" :preview-src-list="srcList"></el-image>
            <el-upload v-else
                       class="avatar-uploader"
                       action="#"
                       :show-file-list="false"
                       :on-remove="handleRemove"
                       :http-request="handleUpload"
                       :before-upload="beforeUpload"
            >
              <img v-if="form.image" :src="form.image" class="avatar"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="paidleClose">关 闭</el-button>
            <el-button type="primary" @click="sureEditPaid('editPaidForm')" :disabled="!isCanSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="refundTitle"
               :visible.sync="refundPaidDialogVisible"
               width="30%"
               center>
      <el-form label-width="120px" :model="refundForm" ref="refundForm" class="editPaidForm">
        <el-form-item label="退款凭证" prop="refund_pic_url" class="list_pic_url">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-remove="refundHandleRemove"
            :http-request="refundHandleUpload"
            :before-upload="refundBeforeUpload"
          >
            <img v-if="formOne.image" :src="formOne.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div style="text-align: center;color: #D9001B">单张图片大小不得超过1M，仅支持jpg、jpeg、png格式</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="refundPaidDialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="refundEditPaid('refundForm')" :disabled="!isCanSubmit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  orderList,
  orderExcel,
  orderDetail,
  addInvoice,
  orderSend,
  popularDeliveryList,
  addSend,
  confirmPayed,
  payReceiptDetail,
  payReceiptUpdate,
  cancelOrder,
  voucherDetail,
  refundVoucher,
  expressType,
  printInfo, printerList, eorderDeliveryList, itemList, deleteLabel, settleOrder
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate, uploadFile} from '../../utils/util'
  import {getToken, upload, uploadImgTmp, uploadPdf} from "../../api/commonMG";

  export default {
    data: () => {
      var validateRate = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入税率'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else if (Number(value) > 100) {
          return callback(new Error('税率不能大于100'));
        } else {
          return callback();
        }
      };
      var validateSalePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入开票金额'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('请输入正确的开票金额'));
        } else {
          return callback();
        }
      };
      return {
        date: '',
        orderId: '',
        sendId: '',
        loading: false, //是显示加载
        sendGoodVisible: false, //控制页面显示与隐藏
        addInvoiceVisible: false,
        editPaidDialogVisible: false,
        refundPaidDialogVisible: false,
        title: '发货单',
        radio: '212',
        invoiceForm: {
          invoice_code: '',
          invoice_no: '',
          invoice_money: '',
          tax_rate: '',
          invoice_date: '',
          invoice_type: '',
          delivery_no: '',
          deliver_comp_id: '',
          deliver_comp: '',
          pdf_url: '',
        },
        deliveryForm: {
          sendDeliveryCode: '',
          deliveryType: '',
          sendDeliveryCompanyId: '',
          sendMode: '',
          deliveryCount: '',
        },
        com_no: "",
        deliveryrules: {
          // sendDeliveryCode: [{required: true, message: '请输入快递单号', trigger: 'change'}],
          sendMode: [{required: true, message: '请选择发货模式', trigger: 'change'}],
          sendDeliveryCompanyId: [{required: true, message: '请选择快递公司', trigger: 'change'}],
          deliveryCount: [{required: true, message: '请输入子母件数量', trigger: 'change'}],
          deliveryType: [{required: true, message: '请选择快递类型', trigger: 'change'}],
        },
        // rules表单验证
        rules: {
          invoice_code: [
            {required: true, message: '请输入发票号', trigger: 'blur'}
          ],
          invoice_no: [{required: false, message: '请输入发票代号', trigger: 'blur'}],
          invoice_money: [{required: true, validator: validateSalePrice, trigger: 'blur'}],
          tax_rate: [{required: true, validator: validateRate, trigger: 'blur'}],
          invoice_date: [{required: true, message: '请选择开票日期', trigger: 'blur'}],
          invoice_type: [{required: true, message: '请选择发票类型', trigger: 'change'}],
          // pdf_url: [{required: true, message: '请选择发票PDF文件', trigger: 'blur'}]
        },
        formInline: {
          page: 1,
          rows: 10,
          Date: '',
          startDate: '',
          endDate: '',
          orderCode: '',
          contactPhone: '',
          orderStatus: '',
          sendStatus: '',
          minAmount: '',
          maxAmount: '',
          custName: '',
          receiverName: '',
          needInvoice: '',
          hasInvoiceBalance: '',
          product_code: '',
          hasPayReceipt:'',
          pay_type: '',
          pay_status: ''
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
        value: '',
        invoiceData: {},
        ordeSendData: [],
        popularDeliveryListData: [],
        compDeliveryListData: [],
        popularcompDeliveryListData: [],
        TypeDeliveryListData: [],
        detailData: {},
        isCanSubmit: true,
        checkSubmit: true,
        isNeedInvoice: '',
        invoice_balance: '',//欠票金额
        imgUrl: '',
        imgRefundUrl: '',
        custInvoiceId: '',
        editPaidForm: {},
        refundForm: {
        },
        form: {
          image: ''
        },
        formOne: {
          image: ''
        },
        selectTableData: [],
        isShowEditPaid: true,
        receipt_img_id: '',
        refund_voucher_img_id: '',
        paidTitle: '',
        refundTitle: '',
        ajaxType:'',
        srcList:[],
        refundList: [],
        PdfDefaultImgIndex: 0,
        defaultVideoImg: '/static/img/pdf.png',
        productPdfUrl: [],
        productPdfFilesList: [],
        videoloading: false,
        comnoid: '',
        siid: '',
        submit_time: '',
        order_code: '',
        order_id: '',
        ids: '',
        labelForm: {
          ids: []
        },
        isSupplier: 0
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    /**
     * 创建完毕
     */
    created() {
      if (this.$route.query.sendStatus) {
        this.formInline.sendStatus = this.$route.query.sendStatus
        this.getdata(this.formInline)
      } else {
        this.getdata(this.formInline)
      }
    },
    mounted() {
      // let seller_name = localStorage.getItem('seller_name')
      // console.log(seller_name)
      // if (seller_name.indexOf('辽宁中联医药有限公司') > -1) {
      //   this.isShowEditPaid = true;
      // } else {
      //   this.isShowEditPaid = false;
      // }
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      rowKey () {
        return
      },
      lookInvoice() {
        window.open(this.invoiceForm.pdf_url)
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        orderList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.totalSize
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        if (this.formInline.Date) {
          this.formInline.startDate = timestampToDate(this.formInline.Date[0])
          this.formInline.endDate = timestampToDate(this.formInline.Date[1])
        } else {
          this.formInline.startDate = ''
          this.formInline.endDate = ''
        }
        this.formInline.page = 1;
        if (this.formInline.minAmount && !(/(^[1-9]\d*$)/.test(this.formInline.minAmount))) {
          this.$message.error('价格区间请输入正整数!');
          return
        }
        if (this.formInline.maxAmount && !(/(^[1-9]\d*$)/.test(this.formInline.maxAmount))) {
          this.$message.error('价格区间请输入正整数!');
          return
        }
        if (Number(this.formInline.minAmount) > Number(this.formInline.maxAmount)) {
          this.$message.error('价格区间错误,请从小到大填写!');
          return
        }
        this.getdata(this.formInline)
      },
      //发货单
      sendGood: function (send_id, id, time, code) {
        this.sendId = send_id;
        this.orderId = id;
        this.submit_time = time;
        this.order_code = code;
        this.deliveryForm = {
          deliveryCount: 1,
          sendMode: "2740",
          sendDeliveryCode: '',
          deliveryType: '',
          sendDeliveryCompanyId: '',
        };
        this.sendGoodVisible = true;
        this.currentPage = 1;
        orderDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailData = res.content || '';
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        orderSend(send_id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.ordeSendData = res.content
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        let data = {
          page: 0,
          rows: 10,
          name: ""
        }
        popularDeliveryList(data)
          .then(res => {
            if (res.success) {
              this.compDeliveryListData = res.content;
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      deliverChange(name) {
        this.popularDeliveryListData.forEach((item) => {
          if (item.name == name) {
            this.invoiceForm.deliver_comp_id = item.id
          }
        })
      },
      compChange(sendDeliveryCompanyId,deliveryType) {
        for(let i in this.compDeliveryListData) {
          if(this.compDeliveryListData[i].id == sendDeliveryCompanyId) {
            this.comnoid = this.compDeliveryListData[i].id
          }
        }
        this.$set(this.deliveryForm, "deliveryType", "");
        expressType(sendDeliveryCompanyId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
               this.TypeDeliveryListData = res.content;
               this.deliveryForm.deliveryType = deliveryType;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      popularCompChange(sendDeliveryCompanyId,deliveryType) {
        for(let i in this.popularcompDeliveryListData) {
          if(this.popularcompDeliveryListData[i].com_no == sendDeliveryCompanyId) {
            this.comnoid = this.popularcompDeliveryListData[i].id
          }
        }
        this.$set(this.deliveryForm, "deliveryType", "");
        expressType(sendDeliveryCompanyId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.TypeDeliveryListData = res.content;
                this.deliveryForm.deliveryType = deliveryType;
                this.deliveryForm.deliveryType = res.content[0].code;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.sendGoodVisible = false;
        this.$refs["deliveryForm"].resetFields();
      },
      gotoInvoice(id, time, code) {
        localStorage.setItem('path', '/order/invoiceOrder')
        let tag = {
          url: "/order/invoiceOrder",
          menuname: "发货单"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/order/invoiceOrder', query: {id: id, time: time, code: code}})
      },
      //跳转订单详情
      gotoOrderDetail(id) {
        localStorage.setItem('path', '/order/orderDetail')
        let tag = {
          url: "/order/orderDetail",
          menuname: "订单详情"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/order/orderDetail', query: {id: id}})
      },
      // 代发详情
      proxyDetail(id) {
        localStorage.setItem('path', '/order/proxyDetails')
        let tag = {
          url: "/order/proxyDetails",
          menuname: "代发详情"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/order/proxyDetails', query: {id: id}})
      },
      // 点击复制
      copy(name, phone, addr) {
        let url = name + ',' + phone + ',' + addr;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
      //添加发票
      addInvoice(order_code, id, invoice_balance) {
        this.order_code = order_code;
        this.orderId = id;
        this.invoice_balance = invoice_balance;
        this.addInvoiceVisible = true;
        this.invoiceForm = {}
        this.form.image = '';
        this.imgUrl = '';
        orderDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.invoiceData = res.content.invoice || '';
              this.isNeedInvoice = res.content.need_invoice;
              this.custInvoiceId = res.content.invoice_id;
              if (res.content.invoice) {
                this.invoiceForm.invoice_money = res.content.invoice.invoice_balance || 0
              }

            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        let data = {
          "page": 1,
          "rows": 10,
          "name": ""
        }
        popularDeliveryList(data)
          .then(res => {
            if (res.success) {
              this.popularDeliveryListData = res.content;
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //导出
      exportExcel() {
        orderExcel(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '订单信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.label == '订单实付金额') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else if (column.label == '欠票金额') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      getSendSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index];
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      checkDate(date) {
        if (/^(\d{4})-(\d{2})-(\d{2})$/.test(date)) {
          return true
        } else {
          return false
        }
      },
      submitInvoiceForm(formName) {
        if (this.invoiceForm.invoice_money > this.invoice_balance) {
          this.$message.error('开票金额不能大于欠票金额!');
          return
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.isCanSubmit = false;
            if (!this.checkDate(this.invoiceForm.invoice_date)) {
              this.invoiceForm.invoice_date = timestampToDate(this.invoiceForm.invoice_date)
            }
            addInvoice(this.orderId, this.custInvoiceId, this.invoiceForm)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '保存成功'
                  })
                  this.addInvoiceVisible = false;
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //删除
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      //批量删除
      batchDeleteRow() {
        var sendTable = this.ordeSendData;
        this.$refs.multipleTable.selection.forEach((Ele, index) => {
          for (var i = 0; i < sendTable.length; i++) {
            var id = sendTable[i].id;
            if (id == Ele.id) {
              sendTable.splice(i, 1);
            }
          }
          this.$refs.multipleTable.clearSelection();
        });
      },
      reviseNum(sendNum, require_send_num, sendEdNum) {
        if (!(/(^[1-9]\d*$)/.test(sendNum))) {
          this.$message.error('请输入正整数!');
          return
        }
        if (sendNum > require_send_num - sendEdNum) {
          this.$message.error('实际发货数不能大于可发货数!');
          return
        }
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.mobile == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
      //关闭弹窗时的操作
      handleClose() {
        this.$refs["invoiceForm"].resetFields();
        this.addInvoiceVisible = false;
        this.productPdfUrl = [];
      },
      //关闭弹窗时的操作
      paidleClose() {
        this.$refs["editPaidForm"].resetFields();
        this.editPaidDialogVisible = false;
      },
      //确认发货
      submitSendForm(formName) {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        this.id = this.selectTableData[0].id;
        this.isCanSubmit = true;
        let parameter = {
          orderId: this.orderId,
          sendId: this.sendId,
          sendDeliveryCompanyId: this.comnoid,
          sendDeliveryCode: this.deliveryForm.sendDeliveryCode,
          deliveryType: this.deliveryForm.deliveryType,
          sendMode: this.deliveryForm.sendMode,
          deliveryCount: this.deliveryForm.deliveryCount,
          siid: this.siid,
          sendDeliverymark: "",
          sendItems: []
        }
        this.selectTableData.forEach((data) => {
          let obj = {
            id: data.id,
            sendNum: data.sendNum,
            maxSendNum: data.require_send_num,
            send_id: this.sendId,
            product_id: data.product_id,
          }
          parameter.sendItems.push(obj)
          if (!(/(^[1-9]\d*$)/.test(data.sendNum))) {
            this.checkSubmit = false
            return
          } else {
            this.checkSubmit = true
          }
          if (data.sendNum > data.require_send_num - data.sendEdNum) {
            this.checkSubmit = false
            return
          } else {
            this.checkSubmit = true
          }
        })
        if (!parameter.sendItems.length) {
          this.$message.error('无待发货商品!');
          return
        }
        if (!this.checkSubmit) {
          this.$message.error('请输入正确的实际发货数!');
          return
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            addSend(parameter)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.success == false) {
                  if (res.code == '-1100') {
                    localStorage.setItem('path', '/order/invoiceOrder')
                    let tag = {
                      url: "/order/invoiceOrder",
                      menuname: "发货单"
                    }
                    this.$store.commit('selectMenu', tag)
                    this.$router.push({path: '/order/invoiceOrder', query: {id: this.sendId, time: this.submit_time, code: this.order_code}})
                    this.sendGoodVisible = false;
                    this.$refs["deliveryForm"].resetFields();
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                } else {
                  this.$message({
                    type: 'success',
                    message: '发货成功'
                  })
                  this.sendGoodVisible = false;
                  this.$refs["deliveryForm"].resetFields();
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false;
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      addSelectBox() {
        localStorage.setItem('path', '/store/storePrinter')
        let tag = {
          url: "/store/storePrinter",
          menuname: "绑定打印机"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/store/storePrinter'})
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      // 修改已付款
      editPaid() {
        this.ajaxType = '1'
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].order_status != '101' && this.selectTableData[0].order_status != '100') {
          this.$message.error('请选择已取消或待付款进行操作！');
          return
        }
        this.radio = '212';
        this.paidTitle = '修改支付状态'
        this.orderId = this.selectTableData[0].id;
        this.receipt_img_id = '';
        this.editPaidDialogVisible = true;
        this.form.image = '';
        this.imgUrl = '';
        payReceiptDetail(this.orderId).then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if (res.content) {
              this.imgUrl = res.content.receipt_img_url;
              this.receipt_img_id = res.content.receipt_img_id;
              this.form.image = res.content.receipt_img_url;
              this.srcList.push(res.content.receipt_img_url)
            }
          }
        })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 修改付款凭证按钮
      editPaidVoucher() {
        this.ajaxType = '2'
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].order_status == '106') {
          this.$message.error('已完成的订单不能修改支付凭证！');
          return
        }
        if (!this.selectTableData[0].receipt_img_id) {
          this.$message.error('请选择有支付凭证的订单进行操作！');
          return
        }
        this.orderId = this.selectTableData[0].id;
        this.editPaidDialogVisible = true;
        this.paidTitle = '修改付款凭证'
        payReceiptDetail(this.orderId).then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if (res.content) {
              this.imgUrl = res.content.receipt_img_url;
              this.receipt_img_id = res.content.receipt_img_id;
              this.form.image = res.content.receipt_img_url;
            }
          }
        })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      cancelOrder() {
        this.orderId = this.selectTableData[0].id;
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].order_status != '102'&&this.selectTableData[0].order_status != '104') {
          this.$message.error('请选择已支付或已出库订单进行操作！');
          return
        }
        this.$confirm('确认是否取消该订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          cancelOrder(this.orderId).then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
                this.$message({
                  type: 'success',
                  message: '已成功取消订单'
                })
                this.getdata(this.formInline)
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      handleRemove(file) {
        console.log(file);
      },
      refundHandleRemove(file) {
        console.log(file);
      },
      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      refundHandleUpload(file) {
        console.log(file)
      },
      // 限制图片尺寸
      limitFileWH(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("image", file);
          // //upload为上传的接口
          // upload(fileData).then(res => {
          //   this.imgUrl = res.attrs.file_url;
          //   //对返回的图片地址进行回显
          //   this.$set(this.form, "image", res.attrs.file_url);
          // });
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgUrl =  res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.warning("上传图片仅支持jpg、jpeg、png格式!");
          return false
        }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 1MB!");
          return false
        }
        // const fileData = new FormData();
        // fileData.append("file", file);
        // //upload为上传的接口
        // uploadImgTmp(fileData).then(res => {
        //   this.imgUrl = res.content;
        //   //对返回的图片地址进行回显
        //   this.$set(this.form, "image", res.content);
        // }).catch(err => {
        //   this.loading = false
        //   this.$message.error('上传失败，请稍后再试！')
        // })
        getToken().then(res => {
          if(res) {
            let result = uploadFile(res,file);
            result.then(res => {
              this.imgUrl =  res.data.content.file.fileUrl;
              //对返回的图片地址进行回显
              this.$set(this.form, "image",  res.data.content.file.fileUrl);
            })
          }
        });
        // 调用[限制图片尺寸]函数
        // this.limitFileWH(240, 240, file)
      },
      // 修改已付款
      sureEditPaid() {
        if (this.radio == 212) {
          if (this.imgUrl == '') {
            this.$message.error('支付凭证图片不能为空!');
            return
          }
        }
        let data = {
          order_id: this.orderId,
          img_id: this.receipt_img_id,
          img_url: this.imgUrl,
          pay_type: this.radio
        }
        this.loading = true;
        this.isCanSubmit = false;
        if (this.ajaxType=='2') {
          let data = {
            order_id: this.orderId,
            img_url: this.imgUrl,
            img_id: this.receipt_img_id,
            pay_type: this.radio
          }
          payReceiptUpdate(data)
            .then(res => {
              this.isCanSubmit = true;
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功修改支付凭证！'
                })
                this.paidleClose()
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          confirmPayed(data)
            .then(res => {
              this.isCanSubmit = true;
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if (this.radio == 212) {
                  this.$message({
                    type: 'success',
                    message: '您已成功修改订单状态为已支付！'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功挂账订单！'
                  })
                }
                this.paidleClose()
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 上传/修改退款凭证按钮
      refundNote() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].order_status == '100' && this.selectTableData[0].receipt_img_id) {

        } else {
          this.$message.error('请选择已取消且有付款凭证的订单进行操作！');
          return
        }
        this.refundTitle = '上传/修改退款凭证'
        this.orderId = this.selectTableData[0].id;
        this.refundPaidDialogVisible = true;
        this.imgRefundUrl = '';
        this.formOne.image = '';
        voucherDetail(this.orderId).then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if (res.content) {
              this.imgRefundUrl = res.content.refund_voucher_img_url;
              this.refund_voucher_img_id = res.content.refund_voucher_img_id;
              this.formOne.image = res.content.refund_voucher_img_url;
            }
          }
        })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 上传/修改退款凭证确定
      refundEditPaid() {
        if (this.imgRefundUrl == '') {
          this.$message.error('退款凭证图片不能为空!');
          return
        }
        let data = {
          orderId: this.orderId,
          imgId: this.refund_voucher_img_id,
          imgUrl: this.imgRefundUrl
        }
        if(this.refund_voucher_img_id) {
          refundVoucher(data)
            .then(res => {
              this.isCanSubmit = true;
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功修改退款凭证！'
                })
                this.refundPaidDialogVisible = false;
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
           refundVoucher(data)
             .then(res => {
               this.isCanSubmit = true;
               this.loading = false
               if (res.success == false) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {
                 this.$message({
                   type: 'success',
                   message: '已成功上传退款凭证！'
                 })
                 this.refundPaidDialogVisible = false;
                 this.getdata(this.formInline)
               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('网络错误，请稍后再试！')
             })
         }
      },
      // 修改订单商品
      getModifyOrder() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        // has_agent_order为true，有代发商品
        if (this.selectTableData[0].has_agent_order == true) {
          this.$message.error('该订单包含代发商品，不能修改订单商品！');
          return
        }
        if (this.selectTableData[0].order_status != '101') {
          this.$message.error('仅待付款订单可以修改订单商品！');
          return
        }
        localStorage.setItem('path', '/order/modifyOrder')
        let tag = {
          url: "/order/modifyOrder",
          menuname: "修改订单商品"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({
          path: '/order/modifyOrder',
          query: {id: this.selectTableData[0].id}
        })
      },
      // 结算订单
      getOrder() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].order_status <= '101') {
            this.$message.error('待付款的订单不能结算!');
            return
        }
        const title = '是否对订单进行结算？';
        this.$confirm(title, '结算订单', {
          confirmButtonText: '确定结算',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          settleOrder(this.selectTableData[0].id,this.isSupplier)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功结算订单!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 上传/修改退款凭证 限制图片尺寸
      limitRefundFileWH(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("image", file);
          // //upload为上传的接口
          // upload(fileData).then(res => {
          //   this.imgRefundUrl = res.attrs.file_url;
          //   //对返回的图片地址进行回显
          //   this.$set(this.formOne, "image", res.attrs.file_url);
          // });
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgRefundUrl =  res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.formOne, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      // 上传/修改退款凭证
      refundBeforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.warning("上传图片仅支持jpg、jpeg、png格式!");
          return false
        }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 1MB!");
          return false
        }
        // const fileData = new FormData();
        // fileData.append("file", file);
        // //upload为上传的接口
        // uploadImgTmp(fileData).then(res => {
        //   this.imgRefundUrl = res.content;
        //   //对返回的图片地址进行回显
        //   this.$set(this.formOne, "image", res.content);
        // }).catch(err => {
        //   this.loading = false
        //   this.$message.error('上传失败，请稍后再试！')
        // })
        getToken().then(res => {
          if(res) {
            let result = uploadFile(res,file);
            result.then(res => {
              this.imgRefundUrl =  res.data.content.file.fileUrl;
              //对返回的图片地址进行回显
              this.$set(this.formOne, "image",  res.data.content.file.fileUrl);
            })
          }
        });
        // 调用[限制图片尺寸]函数
        // this.limitRefundFileWH(240, 240, file)
      },
      handleMouseLeave(isShowButton, i) {
        this.productPdfUrl[i].isShowButton = false;
      },
      uploadFile(file) {
      },
      delPdf(i) {
        this.productPdfUrl.forEach((item) => {
          this.productPdfUrl.splice(i, 1)
        })
        this.invoiceForm.pdf_url = ''
      },
      handleMouseEnter(isShowButton, i) {
        this.videoDefaultImgIndex = i;
        this.productPdfUrl[i].isShowButton = true;
      },
      uploadDefaultUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.warning("上传图片仅支持jpg、jpeg、png格式!");
          return false
        }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 1MB!");
          return false
        }
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          let width = 240;
          let height = 180;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            let valid = img.width == width && img.height == height;
            valid ? resolve() : reject();
          }
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("file", file);
          // //upload为上传的接口
          // uploadImgTmp(fileData).then(res => {
          //   this.productPdfUrl[this.videoDefaultImgIndex].img_url = res.content
          // }).catch(err => {
          //   this.loading = false
          //   this.$message.error('上传失败，请稍后再试！')
          // })
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.productPdfUrl[this.videoDefaultImgIndex].img_url = res.data.content.file.fileUrl;
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          this.$message({
            type: 'warning',
            message: '上传图片的尺寸应为500*500,当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            duration: 2000
          });
          return Promise.reject()
          return false;//必须加上return false; 才能阻止
        })
        return isSize;
      },
      beforeUploadPdf(file) {
        console.log(file.type)
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (file.type.indexOf('pdf') == -1) {
          this.$message.error('请上传正确的PDF格式');
          return false;
        }
        if (!isLt20M) {
          this.$message.error('上传pdf大小不能超过20MB哦!');
          return false;
        }
        let that = this
        // const fileData = new FormData();
        // fileData.append("file", file);
        // //uploadPdf为上传的接口
        // this.videoloading = true;
        // uploadPdf(fileData).then(res => {
        //   let data = {
        //     img_id: "",
        //     pdf_url: res.content,
        //     img_url: '',
        //     isShowButton: false
        //   }
        //   this.videoloading = false;
        //   that.invoiceForm.pdf_url = res.content;
        //   this.productPdfUrl.push(data)
        // }).catch(err => {
        //   this.videoloading = false
        //   this.$message.error('上传失败，请稍后再试！')
        // })
        this.videoloading = true;
        getToken().then(res => {
          if(res) {
            let result = uploadFile(res,file);
            result.then(res => {
              let data = {
                img_id: "",
                pdf_url: res.data.content.file.fileUrl,
                img_url: '',
                isShowButton: false
              }
              this.videoloading = false;
              that.invoiceForm.pdf_url = res.data.content.file.fileUrl;
              this.productPdfUrl.push(data)
            })
          }
        });
      },
      changeType() {
        this.$nextTick(() => {
          this.$refs["invoiceForm"].clearValidate(['pdf_url', 'deliver_comp', 'delivery_no']);
        });
      },
      changeSendMode() {
        if (this.deliveryForm.sendMode == '2741') {
          // 电子面单快递公司
          let populardata = {
            page: 0,
            rows: 10,
            name: ""
          }
          eorderDeliveryList(populardata)
            .then(res => {
              if (res.success) {
                this.popularcompDeliveryListData = res.content;
              }
            })
            .catch(err => {
              this.$message.error('网络错误，请稍后再试！')
            })
          // 打印机信息
          printInfo()
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if(res.content) {
                  this.siid = res.content;
                }
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
        this.deliveryForm = {
          sendMode: this.deliveryForm.sendMode,
          deliveryCount: this.deliveryForm.deliveryCount,
          sendDeliveryCode: '',
          sendDeliveryCompanyId: '',
          deliveryType: '',
        }
        this.$nextTick(() => {
          this.$refs["deliveryForm"].clearValidate(['sendDeliveryCode', 'deliveryType', 'sendDeliveryCompanyId', 'sendMode', 'deliveryCount']);
        });
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .userRole {
    width: 100%;
  }

  a {
    text-decoration: none;
  }

  .router-link-active {
    text-decoration: none;
  }

  .textCenter {
    text-align: center;
  }

  .inline {
    display: inline-block;
  }

  .w120 {
    width: 120px;
  }

  .w220 {
    width: 220px;
  }

  .lh40 {
    line-height: 40px;
  }

  .ml10 {
    margin-left: 10px;
  }

  .mr12 {
    margin-right: 12px;
  }

  .mt50 {
    margin-top: 50px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .f15 {
    font-size: 15px;
  }

  .f14 {
    font-size: 14px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-input--small {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 375px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .relative {
    position: relative;
  }

  .absolute {
    position: absolute;
  }

  .percentage {
    left: 200px;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader {
    height: 148px;
  }

  /deep/ .list_pic_url label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  .video-list-box {
    width: 148px;
    height: 148px;
    margin-right: 10px;
    margin-bottom: 20px;
    border-radius: 6px;
    position: relative
  }

  .img-mask {
    width: 146px;
    height: 146px;
    line-height: 148px;
    background: #000;
    opacity: 0.6;
    position: absolute;
    z-index: 99;
    text-align: center;
    border-radius: 6px;
  }

  .img-mask i {
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .video-default-img {
    border-radius: 6px;
  }

  .note {
    margin-top: 50px;
  }

  .note span {
    margin-left: 10px;
    font-size: 12px;
    color: #D9001B;
    line-height: 20px;
    text-align: left;
  }

  /deep/ .backRgba {
      background: rgba(0, 0, 0, 0.5) !important;
  }

  .inner {
    width: 120px;
    height: 40px;
    line-height: 40px;
  }

  .bfore :before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  /deep/ .el-message-box__btns {
    text-align: center !important;
  }

  /deep/ .el-table .warning-row {
    background-color: #f0f9eb;
  }

  /deep/ .el-table .success-row {
    background: #f0f9eb;
  }

</style>





// WEBPACK FOOTER //
// src/views/order/AllOrder.vue